import { render, staticRenderFns } from "./RequestRedirectedWorkAreaField.vue?vue&type=template&id=b4309c94&scoped=true&"
import script from "./RequestRedirectedWorkAreaField.vue?vue&type=script&lang=js&"
export * from "./RequestRedirectedWorkAreaField.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b4309c94",
  null
  
)

export default component.exports
import {QSelect,QIcon,QItem,QItemSection,QItemLabel} from 'quasar'
component.options.components = Object.assign({QSelect,QIcon,QItem,QItemSection,QItemLabel}, component.options.components || {})
